import React from 'react';
import PropTypes from 'prop-types';
import moment from 'moment';

import { VIEW_SIZE } from 'utils/device';
import Button, { BUTTON_TYPES } from 'shared-components/Button/Button';
import Timer from '../Timer/Timer';
import styles from './Banner.module.css';

const Banner = ({
  title,
  paragraph,
  backgroundColor,
  faqUrl,
  desktopImageUrl,
  campaignEndDate,
  version,
  viewSize,
  onClickLearnMore,
}) => {
  const date = moment(campaignEndDate).tz('America/Los_Angeles');
  const monthDay = date.format('MMMM D');
  const hour = date.format('h:mm');
  const amPm = Number(date.format('H')) > 12 ? 'p.m.' : 'a.m.';
  const mobileDevices =
    viewSize === VIEW_SIZE.small || viewSize === VIEW_SIZE.medium;
  const backgroundStyle = mobileDevices
    ? { backgroundColor }
    : { backgroundImage: `url(${desktopImageUrl})`, backgroundColor };

  return (
    <div className={styles.container} style={backgroundStyle}>
      <h1 className={styles.title}>{title}</h1>
      <p className={styles.paragraph}>
        Shop until
        <span> {monthDay}</span>
        {` at ${hour} ${amPm} PT*`}
      </p>
      <p className={styles.note}>
        <span>
          {paragraph}
          <a href={faqUrl} target="_blank" rel="noopener noreferrer">
            <i className="fas fa-question-circle" />
          </a>
        </span>
      </p>
      <Button
        buttonType={BUTTON_TYPES.PRIMARY}
        className={styles.button}
        onClick={onClickLearnMore}
      >
        How it works
      </Button>
      <Timer endTime={campaignEndDate} version={version} />
    </div>
  );
};

Banner.propTypes = {
  title: PropTypes.string,
  paragraph: PropTypes.string,
  backgroundColor: PropTypes.string,
  faqUrl: PropTypes.string,
  desktopImageUrl: PropTypes.string,
  campaignEndDate: PropTypes.string,
  version: PropTypes.string.isRequired,
  viewSize: PropTypes.string.isRequired,
  onClickLearnMore: PropTypes.func.isRequired,
};

Banner.defaultProps = {
  title: '',
  paragraph: '',
  backgroundColor: '',
  faqUrl: '',
  desktopImageUrl: '',
  campaignEndDate: '',
};

export default Banner;
